import { useState, useEffect } from 'react';

interface UseScrollDirectionReturn {
  scrollDirection: 'up' | 'down' | null;
  isNearBottom: boolean;
  scrollY: number;
}

export const useScrollDirection = (threshold = 100): UseScrollDirectionReturn => {
  const [scrollDirection, setScrollDirection] = useState<'up' | 'down' | null>(null);
  const [isNearBottom, setIsNearBottom] = useState(false);
  const [scrollY, setScrollY] = useState(0);
  const [lastScrollY, setLastScrollY] = useState(0);

  useEffect(() => {
    const updateScrollInfo = () => {
      const currentScrollY = window.scrollY;
      const documentHeight = document.documentElement.scrollHeight;
      const windowHeight = window.innerHeight;
      
      // Check if near bottom (within 200px of footer)
      const distanceFromBottom = documentHeight - (currentScrollY + windowHeight);
      setIsNearBottom(distanceFromBottom < 200);
      
      // Determine scroll direction (only if scrolled more than threshold)
      if (Math.abs(currentScrollY - lastScrollY) > threshold) {
        if (currentScrollY > lastScrollY) {
          setScrollDirection('down');
        } else {
          setScrollDirection('up');
        }
        setLastScrollY(currentScrollY);
      }
      
      setScrollY(currentScrollY);
    };

    updateScrollInfo(); // Initial call
    window.addEventListener('scroll', updateScrollInfo);
    window.addEventListener('resize', updateScrollInfo);

    return () => {
      window.removeEventListener('scroll', updateScrollInfo);
      window.removeEventListener('resize', updateScrollInfo);
    };
  }, [lastScrollY, threshold]);

  return { scrollDirection, isNearBottom, scrollY };
};